import './App.css';
import Quotes from "./components/Quotes"
import MusicPlayer from './components/MusicPlayer'

function App() {
  return (
     <div>
      <Quotes/>
      <MusicPlayer/>
    </div>
  );
}

export default App;
